import React from "react";
import $ from "jquery";

window.jQuery = $;
window.$ = $;
global.jQuery = $;

const DashboardDefault = React.lazy(() => import("./components/Dashboard/HomeDashboard"));
const DeviceBoardPermanent = React.lazy(() => import("./components/Devices/DeviceBoard"));
// NOC View/Devices Overview
const DeviceOverwatch = React.lazy(() => import("./components/Overwatch/Overwatch"));
// Device Import
const DeviceImport = React.lazy(() => import("./components/DeviceImport/DeviceImport"));
const NetworkSummary = React.lazy(() => import("./components/Network/VNE"));
const Logs = React.lazy(() => import("./components/LogScrut/Logs"));

// Settings
const SystemSettings = React.lazy(() => import("./components/Settings/System"));
const Users = React.lazy(() => import("./components/Settings/Users"));


// Tools
const Ping = React.lazy(() => import("./components/Tools/Ping"));
const Traceroute = React.lazy(() => import("./components/Tools/Traceroute"));
const MTR = React.lazy(() => import("./components/Tools/Mtr"));
const Portscan = React.lazy(() => import("./components/Tools/Portscan"));
const SnmpWalk = React.lazy(() => import("./components/Tools/SNMP Walk"));
const Speedtest = React.lazy(() => import("./components/Tools/Speedtest"));

const WebTracker = React.lazy(() => import("./components/Webtracker/webTracker"));
const AlertManage = React.lazy(() => import("./components/Alert/AlertManage"));
const AlertHistory = React.lazy(() => import("./components/Alert/AlertHistory"));
const AlertTemplates = React.lazy(() => import("./components/Alert/EmailTemplates"));


// Reports
const Reports = React.lazy(() => import("./components/Report/index"));

// const Testing = React.lazy(() => import("./components/Network/live test"));

const routes = [
  { path: "/dashboard", exact: true, name: "Default", component: DashboardDefault, },
  { path: "/overwatch", exact: true, name: "Device Overwatch", component: DeviceOverwatch, },
  { path: "/devices/:deviceId?", name: "Devices", component: DeviceBoardPermanent }, 
  { path: "/devicesimport", exact: true, name: "DeviceImport", component: DeviceImport, },
  { path: "/vne", exact: true, name: "Network Explorer", component: NetworkSummary },
  { path: "/logs", exact: true, name: "Logs", component: Logs },
  { path: "/alerts", exact: true, name: "Alert Manager", component: AlertManage, },
  { path: "/alerthistory", exact: true, name: "Alert History", component: AlertHistory, },
  { path: "/alerttemplates", exact: true, name: "Alert Templates", component: AlertTemplates },

  { path: "/reports", exact: true, name: "Report", component: Reports },
  { path: "/urls", exact: true, name: "Web Trackers", component: WebTracker, },

  { path: "/ping", exact: true, name: "Ping", component: Ping },
  { path: "/traceroute", exact: true, name: "Traceroute", component: Traceroute, },
  { path: "/mtr", exact: true, name: "MTR", component: MTR },
  { path: "/portscan", exact: true, name: "Portscan", component: Portscan },
  { path: "/speedtest", exact: true, name: "Speedtest", component: Speedtest },
  { path: "/snmpwalk", exact: true, name: "SnmpWalk", component: SnmpWalk },

  { path: "/settings", exact: true, name: "Settings", component: SystemSettings },
  { path: "/users", exact: true, name: "Users", component: Users },
  
  //{ path: "/test", exact: true, name: "Testing", component: Testing },

];

export default routes;
